export default {"src":"/_next/static/media/dashboard.b25d1140.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};